// src/pages/Login.js
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import { useTranslation } from 'react-i18next'
import useAuthStore from '../stores/authStore'
import useToastStore from '../stores/toastStore'

const SignUp = () => {
    const { t } = useTranslation()
    const { addToast } = useToastStore()
    const { register, loading, error } = useAuthStore()
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        confirmPassword: '',
    })

    const [validationError, setValidationError] = useState('')

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData((prevData) => ({ ...prevData, [name]: value }))
    }

    const handleRegister = async (e) => {
        e.preventDefault()

        const { email, password, confirmPassword } = formData

        // Check if passwords match
        if (password !== confirmPassword) {
            setValidationError('Passwords do not match')
            return
        }

        // Check if all fields are filled
        if (!email || !password || !confirmPassword) {
            setValidationError('All fields are required')
            return
        }

        // Check if password contains at least one letter and one number
        const letterNumberRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*(),.?":{}|<>]+$/
        if (!letterNumberRegex.test(password)) {
            setValidationError('Password phải chứa chữ và số.')
            return
        }

        try {
            await register({ email, password })
            addToast('Đăng kí thành công!', 'success')
            navigate('/login')
        } catch (err) {
            console.error('Registration error:', err)
        }
    }

    return (
        <div>
            <Header />
            <section className="tf-login tf-section">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="tf-title-heading ct style-1">Đăng ký</h2>

                            <div className="flat-form box-login-social">
                                <div className="form-inner">
                                    <form onSubmit={handleRegister} id="contactform">
                                        <input
                                            id="email"
                                            name="email"
                                            tabIndex="1"
                                            aria-required="true"
                                            required
                                            type="email"
                                            placeholder="Email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                        />
                                        <input
                                            id="password"
                                            name="password"
                                            tabIndex="2"
                                            aria-required="true"
                                            type="password"
                                            placeholder="Password"
                                            required
                                            value={formData.password}
                                            onChange={handleInputChange}
                                        />
                                        <input
                                            id="confirm_password"
                                            name="confirmPassword"
                                            tabIndex="3"
                                            aria-required="true"
                                            type="password"
                                            placeholder="Xác nhận Password"
                                            required
                                            value={formData.confirmPassword}
                                            onChange={handleInputChange}
                                        />
                                        {validationError && <p className="error">{validationError}</p>}
                                        {error && <p className="error">{error}</p>}

                                        <button
                                            type="submit"
                                            className="sc-button style-2 fl-button pri-3"
                                            disabled={loading}
                                        >
                                            <span>Đăng ký</span>
                                        </button>
                                    </form>
                                </div>
                            </div>

                            <div className="flat-form box-login-email mg-t-37">
                                <div className="box-title-login">
                                    <h5>Bạn đã có tài khoản ?</h5>
                                </div>

                                <div className="form-inner">
                                    <Link to="/login" className="sc-button style-2 fl-button pri-3">
                                        <span>Đăng nhập</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default SignUp
